<template>
  <ul class="pref-list">
    <li v-for="area in searchArea" :key="area.code" class="region">
      <nuxt-link :to="url({ area: area.name })">{{
        getAreaName(area.name)
      }}</nuxt-link>
      <ul>
        <li
          v-for="(prefecture, index) in area.prefectures"
          :key="index"
          class="pref"
        >
          <nuxt-link :to="url({ prefecture: prefecture })">{{
            prefecture
          }}</nuxt-link>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { config } from '@/utils/config'
import { createUrl } from '@/utils/create-url'
export default {
  computed: {
    searchArea() {
      return config.searchArea
    }
  },
  methods: {
    url(query) {
      return createUrl.createSearchUrl(query)
    },
    getAreaName(areaName) {
      return areaName + 'エリアのセミナー会場'
    }
  }
}
</script>
